import React, { useEffect } from 'react';

function SetTimeSlot(props) {
  const { firstSlot, values, form } = props;

  const duration = values?.services?.duration;
  const name = values?.services?.name;
  const price = values?.services?.price;

  useEffect(() => {
    const start = firstSlot?.attributes?.start;
    const end = firstSlot?.attributes?.end;

    if (firstSlot && values?.services && duration && values?.service) {
      form.batch(() => {
        form.change('bookingStartDate', {
          date: start,
        });
        form.change('bookingEndDate', {
          date: end,
        });
        form.change('bookingStartTime', start.getTime());
        form.change('bookingEndTime', end.getTime());
      });
    }
  }, [firstSlot, name, duration, price]);

  return <></>;
}

export default SetTimeSlot;
